import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import SyncIcon from "@mui/icons-material/Sync";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const integrationsEjemplo = [
  {
    key: "woocommerce_content",
    name: "WooCommerce – Contenidos",
    status: "connected",
    description: "Sincroniza productos con WooCommerce.",
  },
  {
    key: "woocommerce_orders",
    name: "WooCommerce – Órdenes",
    status: "error",
    description: "Recepción de órdenes desde WooCommerce.",
  },
  {
    key: "bicci_company",
    name: "Bicci – Datos Empresa",
    status: "connected",
    description: "Conexión de empresa a API Bicci.",
  },
  {
    key: "bicci_tracking",
    name: "Bicci – Tracking",
    status: "inactive",
    description: "Sincronización de estados de entrega.",
  },
  {
    key: "mercadolibre_orders",
    name: "MercadoLibre – Órdenes",
    status: "testing",
    description: "Gestión de ventas MercadoLibre.",
  },
];

const statusIcon = {
  connected: <CheckCircleIcon color="success" />,
  error: <ErrorIcon color="error" />,
  testing: <SyncIcon color="primary" />,
  inactive: <Chip label="Inactivo" size="small" />,
};

export default function IntegracionesEmpresaUI({
  integrations,
  currentCompany,
}) {
  // xpress_companies/empresa123/integrations/woo1
  // xpress_integrations/woocommerce_orders
  console.log("IntegracionesEmpresaUI", integrations);
  const navigate = useNavigate();
  // mostrar todos los tipos y validar el estado de cada uno

  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState(null);

  const handleMenuOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelected(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelected(null);
  };

  const cardStyles = { maxWidth: "50%", width: "50%", maxHeight: "400px" };
  const CardContentStyles = {
    overflow: "hidden",
    overflowY: "scroll",
    maxHeight: "30vh",
  };
  return (
    <Card sx={cardStyles}>
      <CardHeader
        title="Integraciones"
        sx={{ backgroundColor: "rgb(89, 30, 143)", color: "white", py: 1 }}
      />
      <CardContent sx={CardContentStyles}>
        <List>
          {integrations.map((integration) => (
            <ListItem
              key={integration.integrationID}
              secondaryAction={
                <IconButton onClick={(e) => handleMenuOpen(e, integration)}>
                  <MoreVertIcon />
                </IconButton>
              }
            >
              <Box
                sx={{
                  minWidth: "70px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon>{statusIcon[integration.status]}</ListItemIcon>
              </Box>
              <ListItemText
                primary={integration.name}
                secondary={integration.description}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            navigate(
              `/dashboard/companies/${currentCompany.companyID}/status/${selected.integrationID}`
            );
            handleMenuClose();
          }}
        >
          Ver configuración
        </MenuItem>
        <MenuItem
          onClick={() => {
            console.log("Force", selected);
            handleMenuClose();
          }}
        >
          Forzar sincronización
        </MenuItem>
        <MenuItem
          onClick={() => {
            console.log("Desconectar", selected);
            handleMenuClose();
          }}
        >
          Desconectar
        </MenuItem>
      </Menu>
    </Card>
  );
}
